import { getTypeOrNull } from '@spotify/confidence-graphql';

import { useCurrentUser } from '../useCurrentUser';

export const useCurrentIdentity = () => {
  const { currentUser, isLoading, error } = useCurrentUser();
  const currentIdentity = getTypeOrNull(currentUser?.identity);
  return {
    currentIdentity,
    isLoading,
    error,
  };
};
